/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * types of resources
 */
export type AppSchemasApiResourcesMediaType =
  (typeof AppSchemasApiResourcesMediaType)[keyof typeof AppSchemasApiResourcesMediaType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AppSchemasApiResourcesMediaType = {
  document: 'document',
  video: 'video',
  presentation: 'presentation',
  image: 'image',
  audio: 'audio',
  jupyter_notebook: 'jupyter_notebook',
  spreadsheet: 'spreadsheet',
  link: 'link',
  archive: 'archive',
} as const;
